import { useEffect } from 'react';

const useOutsideClick = (ref, callback, options = {}) => {
  const {
    ignoreRefs = [],
    ignoreSelectors = [],
  } = options;

  const shouldIgnoreTarget = (target) => {
    if (!target) {
      return false;
    }

    if (Array.isArray(ignoreRefs) &&
      ignoreRefs.some(r => r?.current &&
      r.current.contains(target))
    ) {
      return true;
    }

    if (target.closest && Array.isArray(ignoreSelectors)
      && ignoreSelectors.some(selector => selector && target.closest(selector))) {
      return true;
    }

    return false;
  };

  const handleClick = (e) => {
    if (shouldIgnoreTarget(e.target)) {
      return;
    }

    if (ref.current && !ref.current.contains(e.target)) {
      callback(e);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  });
};

export default useOutsideClick;
